import { render, staticRenderFns } from "./new_good.vue?vue&type=template&id=0493a622&"
import script from "./new_good.vue?vue&type=script&lang=js&"
export * from "./new_good.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports